import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IonSegmentCustomEvent, SegmentChangeEventDetail } from '@ionic/core'
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react'

import { Section } from '../UserProfileSections/types'

type SectionsButtonsTabProps = {
  sections: Section[]
  selectedSectionIndex: number
  handleSectionClick: (
    e: IonSegmentCustomEvent<SegmentChangeEventDetail>
  ) => void
  handleButtonClick?: () => void
}

export const SectionsButtonsTab: FC<SectionsButtonsTabProps> = ({
  sections,
  selectedSectionIndex,
  handleSectionClick,
  handleButtonClick,
}) => {
  const { t } = useTranslation('common')

  return (
    <IonSegment
      className="h-[3.5rem] border-none"
      mode="md"
      scrollable={true}
      value={selectedSectionIndex.toString()}
      onIonChange={handleSectionClick}
    >
      {sections.map((section, index) => (
        <IonSegmentButton
          className="sections-buttons-tab"
          key={section.name}
          value={String(index)}
          onClick={() => {
            if (handleButtonClick) handleButtonClick()
          }}
        >
          <IonLabel>{t(`profile.sections.${section.name}.name`)}</IonLabel>
        </IonSegmentButton>
      ))}
    </IonSegment>
  )
}
